import React, { useRef, useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useHistory } from 'react-router-dom';
import { useStorage64 } from 'hooks/useStorageBase64';
import { VARIANTS_PER_PORTAL } from 'constants/env';
import { BASE_PATH_PORTAL } from 'constants/general';

import InputType from 'components/Forms/InputType';
import InputPassword from 'components/Forms/InputPassword';
import { FacebookLogin } from 'react-facebook-login-component';

import '../Login/style.sass';
import '../Login/facebook.sass';
// import { CheckBox } from 'components';

export default function RegistroFormGuest(props) {
    const {
        dataForm,
        warningMessage,
        urlRedirect,
        responseFacebook,
        isMobile
    } = props;

   /* console.log("dataForm",dataForm);
    console.log("warningMessage",warningMessage);
    console.log("urlRedirect",urlRedirect);
    console.log("responseFacebook",responseFacebook);
    console.log("isMobile",isMobile);
*/

    const { register, handleSubmit, errors, watch } = useForm();
    const [registroGuest, setRegistroGuest] = useState();

    // inicio de sesion con facebook
    const [flaglogin, setFlagLogin] = useState(false);
    const [data, setData] = useStorage64('dataFacebook', '');
    const [carrito, setCarrito] = useStorage64('idCarrito', '')
    const [tokenFacebook, setTokenFacebook] = useStorage64('session_token', '')
    const [success, getSuccess] = useState(false)
    const history = useHistory()
    const [errorFacebook, setErrorFacebook] = useState(false)
    const [acceptAdvertisingByMail, setAcceptAdvertisingByMail] = useState(false);

    const sendFormRegister = data => {
        setRegistroGuest({
            'correo': data.correo,
            'cellphone': data.cellphone
        });
    };

    const handleAcceptAdvertisingByMail = (event) => { 
        setAcceptAdvertisingByMail(event.target.checked);
    }

    useEffect(() => {
        if (registroGuest) {
            dataForm(registroGuest);
            // setErrorFacebook(false);
        }
    }, [registroGuest]);

    // -- Validaciones del formulario
    const valEmail = {
        required: 'El Correo electrónico es requerido',
        pattern: {
            value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: 'El formato de correo electrónico es inválido'
        }
    }
    const valCelular = {
        required: 'El Celular es requerido',
        minLength: {
            value: 10,
            message: 'El número celular debe de contener 10 caracteres'
        },
        maxLength: {
            value: 10,
            message: 'El número celular debe de contener 10 caracteres'
        },
        pattern: {
            value: /[0-9]{10}/,
            message: 'El formato de teléfono es inválido'
        }
    }

    return (
        <>
            {warningMessage
                ? <p className="errorMessageWarning">{warningMessage}</p>
                : null
            }

            <form onSubmit={handleSubmit(sendFormRegister)} className="loginPage form-horizontal">
                <InputType
                    type="email"
                    name="correo"
                    id="correo"
                    placeholder="Correo electrónico"
                    refs={register(valEmail)}
                    autocomplete="email"
                    errorMessage={errors.correo && errors.correo.message}
                />
                <InputType
                    type="tel"
                    name="cellphone"
                    id="cellphone"
                    placeholder="Número telefónico"
                    refs={register(valCelular)}
                    autocomplete="tel"
                    errorMessage={errors.cellphone && errors.cellphone.message}
                    maxLength="10"
                    minLength="10"
                    numeric="true"
                />
                <label className="checkboxContent" htmlFor="newsletter">
                    <input type="checkbox" name="newsletter" id="newsletter" ref={register} />
                    <p>Deseo recibir promociones exclusivas por correo electrónico.</p>
                </label>
                <p className="textTerminos supTerm">
                    Al registrarte aceptas los
                    <a href={`${BASE_PATH_PORTAL  }/terminos-condiciones/`} rel="noopener noreferrer" className="link"> Términos y Condiciones </a>
                    y la
                    <a href={`${BASE_PATH_PORTAL  }/aviso-privacidad/`} rel="noopener noreferrer" className="link"> Política de Privacidad </a>
                    de Sears.
                </p>
                <center>
                    <button className="btn rojo btn-block btn-lg primaryButton">Continuar</button>
                </center>
            </form>
        </>
    )
}
